export const USER_DETAIL_DBKEY = 'user-status';
export const USER_THEME_DBKEY = 'theme';
export const USER_FONT_DBKEY = 'font';
export const USER_NAVIGATOR_DBKEY = 'navigator';

export const TRACKING_DBKEY = 'preference-tracking';
export const CATEGORY_TRACKING_DBKEY = 'category-tracking';
export const USERS_TRACKING_DBKEY = 'users-tracking';
export const SUBSCRIBERS_TRACKING_DBKEY = 'subscribers-tracking';
export const SUBSCRIPTIONS_TRACKING_DBKEY = 'subscriptions-tracking';

export const KEEP_ON_LOGOUT_KEYS = [USER_THEME_DBKEY, USER_FONT_DBKEY];